import { useEffect, useState } from "react";
import Add from "../../../../../icons/add";
import New from "./New";
import List from "./List";
import AddingFarmaciaInventory from "./AddingFarmaciaInventory";
import MultiFarmaciaInventory from "./MultiFarmaciaInventory";

const Productos = () => {
  const [view, setView] = useState(false);
  const [counter, setCounter] = useState(0);
  const [farmaciaInventario, setFarmaciaInventario] = useState(false);
  const [variasFarmaciasView, setVariasFarmaciasView] = useState(false);

  useEffect(() => {}, [counter]);

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between py-4 w-full">
        <p className="font-bold text-2xl shrink-0">
          <strong>Productos</strong>
        </p>
        <div className="flex flex-row flex-nowrap items-center justify-end gap-2 sm:gap-3 w-full min-w-0 overflow-x-auto pb-1 -mx-1 px-1">
          <button
            type="button"
            onClick={() => setView(!view)}
            className="cefa-button w-auto shrink-0 whitespace-nowrap"
          >
            <p>Agregar Producto</p>
            <Add />
          </button>
          <button
            type="button"
            onClick={() => setFarmaciaInventario(true)}
            className="cefa-button w-auto shrink-0 whitespace-nowrap"
          >
            <p>Modificar Inventario</p>
          </button>
          <button
            type="button"
            onClick={() => setVariasFarmaciasView(true)}
            className="cefa-button w-auto shrink-0 whitespace-nowrap"
          >
            <p>Modificar varias farmacias</p>
          </button>
        </div>
      </div>
      <New
        view={view}
        setView={setView}
        counter={counter}
        setCounter={setCounter}
      />
      <AddingFarmaciaInventory
        isVisible={farmaciaInventario}
        setIsVisible={setFarmaciaInventario}
      />
      <MultiFarmaciaInventory
        isVisible={variasFarmaciasView}
        setIsVisible={setVariasFarmaciasView}
      />
      <div className="flex-grow overflow-hidden">
        <List counter={counter} setCounter={setCounter} />
      </div>
    </div>
  );
};

export default Productos;
